<template>
  <div id="selfservicecheckout">
    <article>
      <div class="bo-checkout-body">
        <Spinner v-if="isLoading" />
        <OrderError
          v-if="hasErrors"
          :error="getCurrentErrorMessage"
          :descr="getCurrentErrorDescr"
          :level="getCurrentErrorLevel"
        />
        <article v-else>
          <Header :showFilter="false" />
          <article :class="getBodyClass">
            <h3 v-if="hasItemsInCart === false">
              No hay items agregados en tu pedido aún!
            </h3>
            <p v-if="hasItemsInCart === false">
              Podés agregar volviendo a la página de inicio y seleccionando lo
              que más te guste!
            </p>
            <h4 v-if="hasItemsInCart">Tu pedido:</h4>
            <!-- swipe right section -->
            <div v-if="hasItemsInCart">
              <div>
                <div v-for="(item, index) in getCartItems" :key="index">
                  <SwipeoutItem
                    :item="item"
                    :index="index"
                    @transitionEnd="transitionEnd(index)"
                  />
                </div>
              </div>
            </div>
          </article>
          <FooterCheckout
            :backLink="getSelfServiceBackLink"
            :subTotal="getSubTotal"
            confirmLink="/api/SelfServiceOrderConfirmed"
            @onConfirmingOrder="onConfirmingOrder"
            @onOrderConfirmFailure="onOrderConfirmFailure"
            @onOrderConfirmSuccess="onOrderConfirmSuccess"
          />
        </article>
      </div>
    </article>
  </div>
</template>
<script>
import Header from "../Components/Header";
import FooterCheckout from "../Components/FooterCheckout";
import OrderError from "../Components/OrderError";
import Spinner from "../Components/Spinner";
import cart_mixin from "../mixins/Cart_Mixin";
import mobile_detection from "../mixins/mobile_detection";
import spinner_mixin from "../mixins/Spinner_Mixin";
import order_error_mixin from "../mixins/OrderError_Mixin";
import SwipeoutItem from "../Components/SwipeoutItem.vue";
import { db } from "../plugins/firebase";

export default {
  mixins: [spinner_mixin, order_error_mixin, cart_mixin, mobile_detection],
  name: "SelfServiceCheckout",
  data() {
    return {
      status: 0
    };
  },
  mounted() {
    this.$store.commit("SET_IS_LOADING", false);
    this.$store.commit("SET_CURRENT_ERROR_MESSAGE", null);
    this.$store.commit("SET_CURRENT_ERROR_LEVEL", "success");
    this.$store.commit("SET_CURRENT_ERROR_DESCR", null);

    // let recaptchaScript = document.createElement("script");
    // recaptchaScript.setAttribute(
    //   "src",
    //   "https://www.mercadopago.com.ar/integrations/v1/web-payment-checkout.js"
    // );
    // recaptchaScript.setAttribute(
    //   "data-preference-id",
    //   "3186839-7e1e939b-775f-4e7d-ad1d-048545086bed"
    // );
    // document.getElementById('payment-button').innerHTML = '';
    // document.getElementById('payment-button').appendChild(recaptchaScript);

  },
  methods: {
    transitionEnd(index) {
      this.$store.commit("SET_IS_LOADING", true);
      let selectedProds = this.getSelectedProducts;

      selectedProds.splice(index, 1);

      this.$store.commit("SET_SELECTED_PRODUCTS", selectedProds);
    },
    onConfirmingOrder() {
      this.$store.commit("SET_CURRENT_ERROR_MESSAGE", null);
      this.$store.commit("SET_CURRENT_ERROR_LEVEL", "success");
      this.$store.commit("SET_CURRENT_ERROR_DESCR", null);
      this.$store.commit("SET_IS_LOADING", true);
    },
    onOrderConfirmFailure(message) {
      this.$store.commit(
        "SET_CURRENT_ERROR_MESSAGE",
        "No pudimos confirmar tu pedido :("
      );
      this.$store.commit("SET_CURRENT_ERROR_LEVEL", "error");
      this.$store.commit("SET_CURRENT_ERROR_DESCR", message);
      this.$store.commit("SET_IS_LOADING", false);
    },
    onOrderConfirmSuccess(response) {
      const t = this;
      this.$store.commit("SET_IS_LOADING", false);
      console.log('Confirm success!');
      window.location.href = this.$store.getters.getPaymentLink;


    }
  },
  computed: {
    getSelfServiceBackLink() {
      return `SelfService?${this.$store.getters.getSelfServiceQueryString}`;
    },
    getSubTotal() {
      return;
    },
    getBodyClass() {
      if (this.hasItemsInCart) {
        return "bistro-weborders-body-with-items";
      } else {
        return "bistro-weborders-body";
      }
    }
  },
  data() {
    return {};
  },
  components: {
    Header,
    FooterCheckout,
    OrderError,
    Spinner,
    SwipeoutItem
  }
};
</script>
<style scoped>
.bistro-weborders-body-with-items {
  padding-top: 10vh;
  padding-bottom: 16vh;
  height: 80%;
}
.bistro-weborders-body {
  margin-top: 40vh;
}
.mercadoPagoIFrame {
  height: 100vh;
  width: 100vw;
}
</style>



// WEBPACK FOOTER //
// src/pages/SelfServiceCheckout.vue